import React from "react";
import CTAButton from "./CTAButton";
import { MessagesSquare, Zap, LifeBuoy, Flame } from "lucide-react";

const items = [
  {
    icon: MessagesSquare,
    title: "Comunidade de creators",
    desc: "Troca de experiências reais com quem já está vendendo.",
  },
  {
    icon: Zap,
    title: "Insights Exclusivos",
    desc: "Novidades da plataforma em primeira mão (o que está funcionando agora).",
  },
  {
    icon: LifeBuoy,
    title: "Suporte ativo",
    desc: "Tire dúvidas e receba feedback para destravar o que está travando suas vendas.",
  },
  {
    icon: Flame,
    title: "Estratégias quentes",
    desc: "O que está dando certo vira repertório aplicável (sem enrolação).",
  },
];

const CommunitySection = () => {
  return (
    <section className="section" style={{ background: "#050505" }}>
      <div className="container">
        <div style={{ textAlign: "center", marginBottom: 60 }}>
          <div className="eyebrow">COMUNIDADE VSA</div>
          <h2 className="h-title" style={{ marginTop: 14, maxWidth: 900, marginInline: "auto" }}>
            O que você recebe ao entrar na <span className="yellow">VSA Comunidade</span>
          </h2>
          <p style={{ maxWidth: 760, margin: "22px auto 0", color: "rgba(255,255,255,0.75)", fontSize: 17, lineHeight: 1.7 }}>
            Você entra em um ambiente onde os bastidores viram aprendizado e o resultado de alguém vira o atalho de todo mundo.
          </p>
        </div>

        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
          gap: 22,
        }}>
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <div key={i} className="mod-card" style={{ padding: 30 }}>
                <div style={{
                  width: 52, height: 52, borderRadius: 14,
                  background: "rgba(245,196,0,0.12)",
                  border: "1px solid rgba(245,196,0,0.3)",
                  color: "#F5C400",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  marginBottom: 20,
                }}>
                  <Icon size={24} />
                </div>
                <h3 style={{ fontSize: 20, fontWeight: 800 }}>{it.title}</h3>
                <p style={{ marginTop: 10, color: "rgba(255,255,255,0.7)", fontSize: 14.5, lineHeight: 1.6 }}>{it.desc}</p>
              </div>
            );
          })}
        </div>

        <div style={{ marginTop: 50, display: "flex", justifyContent: "center" }}>
          <CTAButton label="QUERO ENTRAR PARA O VSA" />
        </div>
      </div>
    </section>
  );
};

export default CommunitySection;
